import { downloadFile } from '@core/util/downloadUtils';
import boletoApi from 'app/services/api/boletoApi';
import { generateActionTypes, generateDefaultActions } from 'app/store/defaultReducer';

const HISTORICOREMESSA = '[HISTORICOREMESSA]';

const types = generateActionTypes(HISTORICOREMESSA);

export const HistoricoRemessaTypes = {
  ...types,
};

export const INIT = {};

const defaultActions = generateDefaultActions(HistoricoRemessaTypes);

const carregarRegistros = async (dispatch, queryParams = {}) => {
  try {
    dispatch(HistoricoRemessaActions.setCarregandoRegistros(true));
    const response = await boletoApi.buscarHistorico(queryParams);
    dispatch(HistoricoRemessaActions.buscar(response.data));
  } catch (error) {
    dispatch(HistoricoRemessaActions.erro(error?.response?.data?.message));
  } finally {
    dispatch(HistoricoRemessaActions.setCarregandoRegistros(false));
  }
};

const baixarArquivoRemessa = async (dispatch, uuidArquivo, arquivoRemessa) => {
  try {
    dispatch(HistoricoRemessaActions.setCarregandoRegistros(true));

    const response = await boletoApi.baixarArquivoRemessa(uuidArquivo);

    downloadFile(response.data?.remessa, arquivoRemessa);
  } catch (error) {
    dispatch(HistoricoRemessaActions.erro(error?.response?.data?.message));
  } finally {
    dispatch(HistoricoRemessaActions.setCarregandoRegistros(false));
  }
};

export const HistoricoRemessaActions = {
  ...defaultActions,
  carregarRegistros,
  baixarArquivoRemessa,
};
